import styled from 'styled-components';
import { colors } from 'Constants/Colors';

const container = {
  width: '100%',
  background: colors.BLUE_GRAY,
  height: 'auto',
  minHeight: '100vh',
};

export const styleIcon = {
  color: colors.GREEN,
  marginTop: '.5rem',
  marginBottom: '.5rem',
};

export const Body = styled.div`
  width: 95%;
  margin: auto;
  margin-bottom: 3rem;
`;

export const ContainerTitle = styled.div`
  width: 95%;
  margin: auto;
  margin-bottom: 1rem;
`;

export const ContainerTable = styled.div`
  width: 95%;
  margin: auto;
`;

export const ContainerPriority = styled.div`
  display: flex;
  background: :red;
  justify-content:center;
  align-items: center;
`;

export const ModalHeader = styled.div`
  width: 90%;
  margin: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
`;

export const ModalContainer = styled.div`
  width: 20%;
`;
export const ModalPhoto = styled.div`
  width: 60%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  background: ${colors.GREEN_ULTRA_LIGHT};
`;

export const ModalClose = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;

export const ModalBottom = styled.div`
  width: 98%;
  margin: auto;
  border-top: 0.13rem solid;
  color: ${colors.GRAY};
  display: flex;
  justify-content: space-around;
`;

export const buttonStyle = (outlined = true) => ({
  width: '30%',
  fontWeight: 'bold',
  fontSize: '.8rem',
  marginTop: '1rem',
  marginBottom: '1.5rem',
  color: outlined ? colors.GREEN : colors.WHITE,
  background: outlined ? colors.WHITE : colors.GREEN,
  borderColor: colors.GREEN,
});

export const buttonStyle2 = active => ({
  width: '30%',
  fontWeight: 'bold',
  fontSize: '.8rem',
  marginTop: '1rem',
  marginBottom: '1.5rem',
  color: active ? colors.WHITE : colors.BLACK,
  background: active ? colors.GREEN : colors.GRAY,
  borderColor: colors.GREEN,
});

export const ModalBody = styled.div`
  width: 90%;
  margin: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
export const ModalTitle = styled.div`
  font-weight: bold;
  margin-bottom: 1rem;
  font-family: sans-serif;
`;

export const ModalText = styled.div`
  color: ${colors.GRAY_DARK};
  margin-bottom: 1rem;
`;

export const DropzoneContainer = styled.div`
  width: 100%;
  background: ${colors.GREEN_ULTRA_LIGHT};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;
export const DropzoneArea = styled.div`
  margin-top: 1rem;
  cursor: pointer;
`;
export const DropzoneText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export default container;
